/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from "relay-runtime";

import { FragmentRefs } from "relay-runtime";
export type SageIntacctCreateNewProjectModal_company = {
    readonly clients: {
        readonly edges: ReadonlyArray<{
            readonly node: {
                readonly id: string;
                readonly name: string | null;
                readonly sageIntacctCustomerId: string | null;
            } | null;
        } | null> | null;
    } | null;
    readonly " $refType": "SageIntacctCreateNewProjectModal_company";
};
export type SageIntacctCreateNewProjectModal_company$data = SageIntacctCreateNewProjectModal_company;
export type SageIntacctCreateNewProjectModal_company$key = {
    readonly " $data"?: SageIntacctCreateNewProjectModal_company$data | undefined;
    readonly " $fragmentRefs": FragmentRefs<"SageIntacctCreateNewProjectModal_company">;
};



const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "SageIntacctCreateNewProjectModal_company",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "ClientTypeConnection",
      "kind": "LinkedField",
      "name": "clients",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "ClientTypeEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "Client",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "id",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "name",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "sageIntacctCustomerId",
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Company"
};
(node as any).hash = 'aa4a028a025e0b8d0bd0361a29c6db51';
export default node;
